import { AUTHENTICATE, DEAUTHENTICATE } from "./mutations.type";
import JwtUtilService from "@/services/jwt.util.service";

export default {
  [AUTHENTICATE](state, payload) {
    state.authenticated = true;

    JwtUtilService.setToken(payload.access_token);
    JwtUtilService.setRefreshToken(payload.refresh_token);
    JwtUtilService.setIdToken(payload.id_token);

    window.parent.location = window.location.href;
  },
  [DEAUTHENTICATE](state) {
    state.authenticated = false;

    JwtUtilService.deleteAllCookies();
    JwtUtilService.removeCodeChallenge();
    JwtUtilService.removeCodeVerifier();

    JwtUtilService.removeToken();
    JwtUtilService.removeRefreshToken();
  },
};
